<script>
export default {
	name: 'MaintenanceBanner',
	methods: {
		openModal() {
			this.$modal.show('maintenance-modal')
		},
		closeModal() {
			this.$modal.hide('maintenance-modal')
		},
	},
}
</script>

<template>
	<div>
		<div class="maintenance-banner">
			<span>
				<strong>Внимание!</strong> С 21:00 21 марта по 21:00 23 марта будут проводиться технические работы. Система будет недоступна.
			</span>
			<button class="maintenance-banner__link" @click="openModal">Подробнее</button>
		</div>

		<modal
			class="modal__block modal__block--middle"
			name="maintenance-modal"
			:width="600"
			:min-width="300"
			height="auto"
		>
			<div class="modal__block--wrapper">
				<div class="modal__wrapper">
					<div class="modal__header">
						<div class="modal__title">Уведомление о временной недоступности системы</div>
					</div>
					<div class="modal__content">
						<div class="modal__form maintenance-modal__body">
							<p>Уважаемые пользователи!</p>
							<p>Сообщаем вам о проведении плановых работ по миграции серверного оборудования в новый государственный дата-центр.</p>
							<ul>
								<li><strong>Начало работ:</strong> 21 марта (суббота), 21:00.</li>
								<li><strong>Окончание работ:</strong> 23 марта (понедельник), 21:00.</li>
							</ul>
							<p>В указанный период доступ к информационной системе будет полностью ограничен. Просим заблаговременно сохранить все внесенные данные и завершить текущие сессии.</p>
							<p>Приносим извинения за временные неудобства.</p>

							<div class="reporting-btn mt-4">
								<div class="reporting-wrapper">
									<a class="input-btn form__line--btn form__line--btn-black" @click="closeModal">
										Закрыть
									</a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</modal>
	</div>
</template>

<style scoped>
.maintenance-banner {
	background-color: #fff3cd;
	border-bottom: 1px solid #ffc107;
	color: #7d5a00;
	padding: 10px 20px;
	text-align: center;
	font-size: 14px;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 8px;
	flex-wrap: wrap;
	z-index: 9999;
	position: relative;
}

.maintenance-banner__link {
	background: none;
	border: none;
	color: #0066cc;
	text-decoration: underline;
	cursor: pointer;
	font-size: 14px;
	padding: 0;
}

.maintenance-banner__link:hover {
	color: #004499;
}

.maintenance-modal__body p {
	margin-bottom: 10px;
	font-size: 14px;
	line-height: 1.6;
}

.maintenance-modal__body ul {
	margin: 10px 0 10px 20px;
	list-style: disc;
}

.maintenance-modal__body ul li {
	font-size: 14px;
	line-height: 1.6;
	margin-bottom: 6px;
}
</style>
